import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ISelectOptionGroup } from '../../models/select-option-group';
import { SelectListService } from '../../services/form-utility/select-list.service';
import { ISelectOption } from '../../models/select-option';
import { Subscription, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-radio-input',
  templateUrl: './radio-input.component.html',
  styleUrls: ['./radio-input.component.css'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatInputModule,
  ],
})
export class RadioInputComponent extends BaseInputDirective implements OnInit, OnDestroy {
  private selectListService = inject(SelectListService);

  @Input() fetchData: Observable<ISelectOptionGroup[]>;
  @Input() showRadioHorizontal: boolean = false;
  @Input() hiddenErrorKeys: string[] = [];
  @Output() richChange = new EventEmitter();
  optionGroups: ISelectOptionGroup[];
  filteredGroups: ISelectOptionGroup[] = [];
  hasOneGroup = false;
  flatOptions: ISelectOption[];
  currentSelection = '';
  private initialValue: any;
  selectListChanges: Subscription;

  
 



  ngOnInit() {
    super.ngOnInit();

    this.initialValue = this.formControl.value;

    const dataFetcher =
      this.fetchData || this.selectListService.getSelectList(this.fgInfo.optionList);

    if (dataFetcher) {
      this.selectListChanges = dataFetcher.subscribe(selectOptionGroups => {
        this.optionGroups = selectOptionGroups;

        this.flatOptions = this.selectListService.flattenOptions(this.optionGroups);
        this.currentSelection = this.selectListService
          .getCurrentSelection(this.flatOptions, this.formControl.value)
          .map(x => x.name)
          .join(', ');

        if (this.optionGroups) {
          // Filter out inactive and not-selected options
          this.filteredGroups = [];
          this.filteredGroups = this.selectListService.filterAndSortSelectOptionGroup(
            this.optionGroups,
          );

          if (this.optionGroups.length === 1) {
            this.hasOneGroup = true;
          }

          if (this.initialValue != null) {
            const selections = this.selectListService.getCurrentSelection(
              this.flatOptions,
              this.formControl.value,
            );
            this.richChange.emit(selections);
          }
        }
      });
    } else {
      console.warn(
        `A data fetcher must be passed to the radio input for control '${this.controlName}'. If you don't have an Observable yet, use a BehaviorSubject`,
      );
    }
  }

  ngOnDestroy(): void {
    this.selectListChanges.unsubscribe();
  }

  onChange(event: any) {
    const selections = this.selectListService.getCurrentSelection(
      this.flatOptions,
      this.formControl.value,
    );
    this.currentSelection = selections.map(x => x.name).join(', ');
    this.change.emit(event);
    this.richChange.emit(selections);
  }
}
